<template>
  <div class="awaitAllotWrapper">
    <div class="awaitAllotContainer">
      <!-- 用车申请待分配 -->
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="awaitAllot" v-for="(item, index) in carInfoList" :key="index">
          <div class="checkbox">
            <van-checkbox v-model="item.checked" @click="selectCheckbox(item, index)"></van-checkbox>
          </div>
          <div @click="useCarDetail(item)">
            <div class="awaitAllotTitle">
              <div class="awaitAllotDriver">
                {{ item.applyTitle }}
              </div>
              <div class="tabBtn">
                <span class="btn">{{
                  useTypeList[item.useType - 1]
                }}</span>
              </div>

            </div>
            <div class="allotPlace">
              <div class="allotPlaceItems">
                <div class="place">{{ item.airportName }}</div>
              </div>
              <div class="line">
                <img src="@/assets/car/placeArrows.png" alt="" />
              </div>
              <div class="allotPlaceItems1">
                <div class="place" v-for="(i, int) in item.addressInfoList" :key="int">{{ i.useLocation }}</div>
              </div>
            </div>
            <div class="splitLine"></div>
            <div class="useDetail">
              <div class="personNum">人数：{{ item.useNumber }}</div>
              <div>
                用车时间：<span style="font-size: 13px">{{
                  item.useSaterTime + " - " + item.useEndTime
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div style="position: fixed; bottom: 0" v-if="carInfoList.length > 0" class="footerBtn">
      <van-button @click="cancel" type="default" size="small" native-type="button" style="width: 30%">返回</van-button>
      <van-button type="info" size="small" @click="allotCar" style="width: 30%; background-color: #4ea27c">分配</van-button>
      <van-button type="info" size="small" @click="cancelAppointment"
        style="width: 30%; background-color: #e86d6d">取消预约</van-button>

    </div>
  </div>
</template>

<script>
import apis from "@/apis/car";
import moment from "moment";
import "@/assets/car/icon/iconfont.css";
export default {
  name: "awaitAllot",
  props: {
    active: {
      default: null,
    }
  },
  data() {
    return {
      carInfo: {
        department: this.$store.state.userInfo.department,
        nickname: this.$store.state.userInfo.nickname
      },
      showAllot: false,
      checked: false,
      page: 1,
      pageSize: 200,
      totalAll: 0,
      loading: false,
      finished: false,
      carInfoList: [],
      checkedItems: [],
      useTypeList: ["客户接待", "接机", '送机', "供应商考察", "其他"],
    };
  },
  mounted() { },
  activated() {
    this.checkedItems = [];
  },
  methods: {
    // 初始化获取列表
    onLoad() {
      this.queryUseCarAllot();
    },
    // 获取用车申请待分配列表
    queryUseCarAllot() {
      const json = {
        applyState: 2,
        page: this.page,
        pageSize: this.pageSize,
        zoneId: localStorage.getItem('cityId')
      };
      apis.queryUseCarAllotList(json).then(res => {
        if (res.code === 200) {
          this.totalAll = res.data.total;
          this.finished = false;
          if (this.page === 1) {
            this.carInfoList = res.data.list;
          } else {
            this.carInfoList = this.carInfoList.concat(res.data.list);
          }
          if (this.carInfoList.length < this.totalAll) {
            this.page = this.page + 1;
          } else {
            this.finished = true;
          }
          this.loading = false;

          this.carInfoList = this.carInfoList.map(item => {
            item.useSaterTime = moment(new Date(item.useSaterTime)).format(
              "YYYY-MM-DD HH:mm"
            );
            item.useEndTime = moment(new Date(item.useEndTime)).format(
              "YYYY-MM-DD HH:mm"
            );
            item.checked = false;
            return item;
          });
          console.log('this.carInfoList', this.carInfoList);
        }
      });
    },
    //多选框 选中
    selectCheckbox(item, itemIndex) {
      console.log(item, itemIndex);
      this.checkedItems = [];
      this.carInfoList = this.carInfoList.map((i, index) => {
        if (item.checked) {
          if (index === itemIndex) {
            i.checked = true;
          }
        }
        return i;
      });
      this.checkedItems = this.carInfoList.filter(item => item.checked);
    },
    //跳转用车申请详情
    useCarDetail(item) {
      localStorage.setItem('active', this.active);
      this.$router.push(
        `/car/facility/alreadyAllotDetail?applyNumber=${item.applyNumber}&isReadonly=${true}`
      );
    },
    //返回
    cancel() {
      // this.$router.push("/car/facility/index");
      this.$router.go(-1);
    },
    //分配
    allotCar() {
      localStorage.setItem('active', this.active);
      if (this.checkedItems.length > 0) {
        localStorage.setItem('allotCarDetail', JSON.stringify(this.checkedItems));
        this.$router.push(
          '/car/facility/carManage/carAllot'
        );
      } else {
        return this.$toast("请选择待分配预约");
      }
    },
    // 取消分配
    cancelAppointment() {
      if (this.checkedItems.length > 0) {
        const applyNumbers = this.checkedItems.map(item => item.applyNumber);
        let obj = {
          applyNumber: applyNumbers.toString(),
        };
        apis
          .batchCancelReservation(obj)
          .then(res => {
            if (res.code == "200") {
              this.$dialog({
                message: "已经发起OA流成 需要取消请OA撤回",
                confirmButtonText:'我知道了'
              });
              this.onLoad();
            }
          });
      } else {
        return this.$toast("请选择需要取消的预约");
      }

    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .awaitAllotWrapper {
    width: 100%;
  }

  .footerBtn {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .awaitAllotWrapper {
    width: 276px * $zoom;
  }

  .footerBtn {
    width: 276px * $zoom;
  }
}

.awaitAllotWrapper {
  .awaitAllotContainer {
    padding: 29px;
    margin-top: 22px;
    height: calc(84vh);
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .awaitAllot {
      background-color: #fff;
      margin-bottom: 20px;
      border-radius: 9px;
      padding: 0 26px;
      position: relative;

      .checkbox {
        position: absolute;
        right: 20px;
        top: 20px;
      }

      .awaitAllotTitle {
        display: flex;
        padding-top: 5px;


        ::v-deep(.van-checkbox__icon .van-icon) {
          width: 30px;
          height: 30px;
        }

        ::v-deep .van-icon-success:before {
          height: 30px;
        }

        .awaitAllotDriver {
          font-size: 27px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: #282b32;
          margin-right: 20px;
          padding-top: 36px;
        }

        .tabBtn {
          height: 40px;
          background-color: #fff3e8;
          border-radius: 6px;
          padding: 0 10px;
          margin-top: 36px;
          display: flex;
          align-items: center;
          justify-content: center;

          .btn {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff8e20;
          }
        }

      }

      .allotPlace {
        display: flex;
        align-items: center;
        margin: 53px 0;

        .line {
          width: 50px;
          height: 7px;
          display: flex;
          align-items: center;
          margin: 0 18px;

          img {
            width: 50px;
            height: 7px;
          }
        }

        .allotPlaceItems {
          min-width: 23%;
          max-width: 29%;

          .place {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 23px;
            // font-weight: bold;
            color: #4ea27c;
          }
        }

        .allotPlaceItems1 {
          min-width: 23%;
          max-width: 87%;

          .place {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 23px;
            // font-weight: bold;
            color: #4ea27c;
          }
        }
      }

      .splitLine {
        width: 100%;
        height: 1px;
        border: 1px solid #f1f1f1;
        margin-bottom: 37px;
      }

      .useDetail {
        // display: flex;
        // justify-content: space-between;

        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        // margin: 0 10px 0 20px;
        padding-bottom: 36px;
      }

      .personNum {
        margin-bottom: 20px;
      }
    }

    .popupAllot {
      padding: 30px;

      .items {
        border: 1px solid #cccccc;
        padding: 3px 5px 5px 20px;
        margin-bottom: 20px;

        .itemsCarInfo {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .plateNum {
            font-size: 23px;
          }

          .carStatus {
            ::v-deep(.van-button--small) {
              height: 36px;
            }
          }
        }

        .userInfo {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 23px;
          margin-top: 30px;

          .userPhone {
            display: flex;
            align-items: flex-start;

            .userInfoCheckbox {
              margin-left: 10px;

              ::v-deep(.van-checkbox__icon .van-icon) {
                width: 30px;
                height: 30px;
              }
            }
          }
        }
      }
    }
  }

  .footerBtn {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 0;
      font-size: 27px;
      border: 0;
    }
  }
}
</style>
